/* eslint-disable no-mixed-operators */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { useState, useEffect } from 'react'
import {
  makeStyles,
  Grid,
  Typography,
  Card,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
} from '@material-ui/core'
import { v4 as uuid } from 'uuid'
import {
  useDispatch,
  useSelector,
} from 'react-redux'
import {
  useParams, useNavigate,
} from 'react-router-dom'
import './NewDisc.css'
import styles from './Disk.module.css'
import {
  answerQuiz,
  selectorAnsweredExam, getUserAnswered, finishQuiz,
  selectorFinishResult,
} from '../../app/slices/examSlice'
import { selectUserInfo } from '../../app/slices/userSlice'
import { selectorUsersPackage, getUsersPackages } from '../../app/slices/packageSlice'

const useStyles = makeStyles(() => ({
  root: {
    // overflowX: 'hidden !important',
    '&.MuiPaper-root': {
    },
  },
  cardWrapper: {
    padding: '32px 37px 35px 33px',
    borderRadius: '10px',
    '@media (max-width: 970px)': {
      padding: '32px 27px 35px 25px',
    },
  },
  title: {
    color: '#000000',
    fontSize: '18px',
    fontWeight: 'bold',
  },
  desc: {
    color: '#888888',
    fontSize: '16px',
    fontWeight: '300',
    marginTop: '10px',
    marginBottom: '30px',
  },
  listTile: {
    color: '#052b56',
    fontSize: '16px',
    fontWeight: 'bold',
    marginBottom: '5px',
  },
  mainList: {
    display: 'flex',
    flexFlow: 'column',
    // overflowX: 'auto',
    // overflowY: 'hidden',
    // minWidth: '900px',
    // width: '100%',
    '@media (max-width: 760px)': {
      width: '110%',
    },
    '@media (max-width: 620px)': {
      // width: '650px',
      width: '109%',
    },
    '@media (max-width: 500px)': {
      // minWidth: '420px',
      width: '108%',
      paddingBottom: '10px',
    },
    '@media (max-width: 460px)': {
      // minWidth: '280px',
      width: '102%',
      paddingBottom: '10px',
    },
    '@media (max-width: 360px)': {
      // minWidth: '250px',
      paddingBottom: '10px',
    },
  },
  listTitle: {
    backgroundColor: '#dff5fe',
    padding: '9px',
    borderRadius: '10px',
    fontWeight: '500',
  },
  listTitle1: {
    backgroundColor: '#dff5fe',
    padding: '9px',
    borderRadius: '10px',
    fontWeight: '600',
    width: '50px',
    margin: '5px 0',
    marginRight: '0 !important',
    fontSize: '14px',
    textAlign: 'center',
  },
  listTitle2: {
    backgroundColor: '#dff5fe',
    padding: '9px',
    borderRadius: '10px',
    fontWeight: '600',
    width: '80%',
    margin: '5px',
  },
  listTitle3: {
    backgroundColor: '#dff5fe',
    padding: '9px',
    borderRadius: '10px',
    fontWeight: '600',
    width: '68px',
    margin: '5px 0 5px 5px',
    textAlign: 'center',
    // '@media (max-width: 760px)': {
    // display: 'none',
    // },
  },
  listTitle4: {
    backgroundColor: '#dff5fe',
    padding: '9px',
    borderRadius: '10px',
    fontWeight: '600',
    width: '68px',
    margin: '5px 5px 5px 0',
    textAlign: 'center',
  },
  lists: {
    display: 'flex',
    flexFlow: 'row',
    justifyContent: 'flex-start',
    alignItems: 'end',
    padding: '0 !important',
  },
  listsStatic: {
    display: 'flex',
    flexFlow: 'row',
    justifyContent: 'flex-start',
    alignItems: 'end',
    padding: '0 !important',
    marginBottom: '10px',
  },
  radio: {
    width: '60px',
    margin: '0 4px',
  },
  perList1: {
    width: '50px',
    height: '45px !important',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '5px 2px',
    marginRight: '4px',
    borderRadius: '10px',
    border: '1px solid #d8d8d8',
    // '@media (max-width: 460px)': {
    // padding: '30px 8px',
    // },
  },
  perList2: {
    width: '80%',
    height: '45px',
    textAlign: 'left',
    marginRight: '5px',
    borderRadius: '10px',
    border: '1px solid #d8d8d8',
    padding: '14px 8px',
    display: 'flex',
    alignItems: 'center',
    '@media (max-width: 620px)': {
      padding: '30px 8px',
    },
    '@media (max-width: 460px)': {
      padding: '50px 8px',
    },
    '@media (max-width: 360px)': {
      padding: '67px 8px',
    },
  },
  perList3: {
    width: '138px',
    height: '45px',
    textAlign: 'center',
    borderRadius: '10px',
    marginRaight: '10px',
    border: '1px solid #d8d8d8',
    display: 'flex',
    flexFlow: 'row',
    marginLeft: '8px',
    '@media (max-width: 760px)': {
      display: 'none',
    },
  },
  perList3InModal: {
    width: '138px',
    height: '45px',
    textAlign: 'center',
    borderRadius: '10px',
    marginRaight: '10px',
    border: '1px solid #d8d8d8',
    display: 'flex',
    flexFlow: 'row',
    marginLeft: '8px',
    // '@media (max-width: 760px)': {
    // display: 'none',
    // },
  },
  submitBtn: {
    backgroundColor: '#f9b233',
    width: '154px',
    height: '41px',
    borderRadius: '10px',
    padding: '7px 41px',
    fontSize: '16px',
    fontWeight: 'bold',
    whiteSpace: 'nowrap',
    border: 'none',
    float: 'right',
    marginTop: '25px',
  },
  submitText: {
    display: 'block',
    fontSize: '14px',
    fontWeight: 'normal',
    // whiteSpace: 'nowrap',
    color: '#888888',
    whiteSpace: 'pre-line',
  },
  submitWrap: {
    marginTop: '100px',

    display: 'flex',
    flexFlow: 'column',
    alignItems: 'end',
  },
  listContainer: {
    marginBottom: '50px',
  },
  radioWrap: {
    display: 'flex',
    flexFlow: 'row !important',
    flexDirection: 'row !important',
  },
  deleteDialog: {
    '& .MuiDialog-paperWidthSm': {
      // width: '587px',
      width: '50%',
      height: '189px',
      borderRadius: '20px',
      padding: '0 0 11px',
      backgroundColor: '#fff',
      margin: '22px 94.6px 36px 110.5px',
    },
    '& .MuiBackdrop-root': {
      opacity: '0.6 !important',
      backgroundColor: '#363853',
    },
  },
  answerModal: {
    '& .MuiDialog-paperWidthSm': {
      // width: '300px',
      boxShadow: 'none',
      height: '290px',
      borderRadius: '20px',
      padding: '10px 10px 11px',
      // backgroundColor: '#fff',
      // margin: '22px 94.6px 36px 110.5px',
      '@media (max-width: 620px)': {
        // width: '300px',
      },
      '@media (max-width: 430px)': {
        // width: '300px !important',
      },
    },
    // '& .MuiBackdrop-root': {
    //   opacity: '0.014 !important',
    //   backgroundColor: '#363853',
    // },
  },
  dialogHeader: {
    width: '100%',
    height: '53px',
    backgroundImage: 'linear-gradient(#a5a5a5, #b5b5b5)',
    color: '#000',
    '& .MuiTypography-h6': {
      fontWeight: '600',
      fontSize: '17px',
      // '@media (max-width: 960px)': {
      // fontSize: '15px',
      // },
    },
  },
  dialogDesc: {
    fontWeight: '600',
    fontSize: '15px',
    marginTop: '10px',
    color: '#363853',
    textAlign: 'justify !important',
    // '@media (max-width: 960px)': {
    // fontSize: '14px',
    // },
  },
  dialogButtons: {
    marginRight: '20px',
  },
  cancelModalBtn: {
    backgroundColor: '#ffffff',
    width: '25%',
    height: '37px',
    borderRadius: '20px',
    color: '#000',
    textAlign: 'center',
    border: '2px solid #e6332a',
    fontWeight: '600',
    '&:hover': {
      backgroundColor: '#e6332a',
      boxShadow: '0 2px 6px 0 rgba(197, 0, 0, 0.36)',
      color: '#ffffff',
    },
  },
  finalSubmit: {
    backgroundColor: '#ffffff',
    width: '25%',
    height: '37px',
    borderRadius: '20px',
    color: '#000',
    textAlign: 'center',
    border: '2px solid #f9b233',

    fontWeight: '600',
    '&:hover': {
      backgroundColor: '#f9b233',
      boxShadow: '0 2px 6px 0 rgba(197, 0, 0, 0.36)',
      color: '#ffffff',
    },
  },
}))

function DiscQuizCard({ discs }) {
  const classes = useStyles()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const answeredExam = useSelector(selectorAnsweredExam)
  const userExams = useSelector(selectorUsersPackage)
  const finishedResponse = useSelector(selectorFinishResult)
  const { role, userId } = useSelector(selectUserInfo)
  const { examId } = useParams()
  const [isValid, setIsValid] = useState(false)
  const [submitModal, setSubmitModal] = useState(false)
  const [question, setQuestion] = useState(null)

  const uniqNumber = uuid()

  useEffect(() => {
    dispatch(getUserAnswered({
      userid: userId, userexamid: examId, first: 200, after: 0,
    }))
    dispatch(getUsersPackages())
  }, [window.innerWidth])

  const getUserExam = userExams?.find((item) => item?.id === +examId)

  const handleHighChange = (item, exam) => (e) => {
    const optionIndex = item?.options?.findIndex((option) => option?.id === exam?.id)

    if (e.target.checked) {
      const data = {
        userExam: {
          id: examId,
          lastAnsweredQuestionIndex: optionIndex,
        },
        question: {
          id: item?.id,
        },
        ExamTag: {
          id: getUserExam?.exam?.examTags?.[0]?.id,
        },
        examOption: {
          id: exam?.id,
        },
      }

      dispatch(answerQuiz(data, () => dispatch(getUserAnswered({
        userid: userId, userexamid: examId, first: 200, after: 0,
      }))))
    } else {
      e.target.parentElement.previousElementSibling.children[0].checked = false
    }
  }

  const handleLowChange = (item, exam) => (e) => {
    const optionIndex = item?.options?.findIndex((option) => option?.id === exam?.id)

    if (e.target.checked) {
      const data = {
        userExam: {
          id: examId,
          lastAnsweredQuestionIndex: optionIndex,
        },
        question: {
          id: item?.id,
        },
        ExamTag: {
          id: getUserExam?.exam?.examTags?.[1]?.id,
        },
        examOption: {
          id: exam?.id,
        },
      }

      dispatch(answerQuiz(data, () => dispatch(getUserAnswered({
        userid: userId, userexamid: examId, first: 200, after: 0,
      }))))
    } else {
      e.target.parentElement.nextElementSibling.children[0].disabled = false
    }
  }

  const handleSubmit = () => {
    // e.preventDefault()
    if (answeredExam?.length === 56) {
      setIsValid(false)
      dispatch(finishQuiz(examId))
      if (finishedResponse?.data?.code === 200 || finishedResponse?.data?.success === true) {
        setSubmitModal(false)
        navigate('/app/exams/user/')
      }
    } else if (answeredExam?.length < 56) {
      setIsValid(true)
      setSubmitModal(false)
    }
  }

  const handleOpen = () => {
    if (finishedResponse !== 'Exam has been finished') {
      if (answeredExam?.length === 56) {
        setSubmitModal(true)
        setIsValid(false)
      } else {
        setIsValid(true)
        setSubmitModal(false)
      }
    }
  }

  const handleOpenAnswer = (item) => {
    if (window.innerWidth < 760) {
      setQuestion(item)
    }
  }

  const handleCloseAnswer = () => {
    setQuestion(null)
  }

  const handleClose = () => {
    setSubmitModal(false)
  }

  return (
    <div className={styles.container}>
      <Card className={classes.root}>
        <Grid className={classes.cardWrapper}>
          <Grid item>
            <Typography className={classes.title}>
              راهنمای پاسخگویی به آزمون رفتارشناسی گارنت
            </Typography>
          </Grid>
          <Grid style={{ textAlign: 'justify' }} item>
            <Typography className={classes.desc}>
              به کمک آزمون رفتارشناسی می‌توانید خود و دیگران را بهتر بشناسید
              و با این شناخت مسیر زندگی خود را در سنین نوجوانی پیدا کنید.
              <br />
              <br />
              برای پاسخ به سؤال‌ها تمام عبارت‌ها
              را بادقت بخوانید باتوجه‌به شناختی که از خود دارید، عبارتی
              که بیشترین شباهت به شما دارد را به‌عنوان بیشترین و
              عبارتی که کمترین شباهت به شما دارد را به‌عنوان کمترین انتخاب کنید.
              حتماً تمام سؤالات را بادقت بخوانید و برای پاسخ از خانواده خود کمک بگیرید
            </Typography>
          </Grid>

          <div style={{
            // maxWidth: '300px',
          }}
          >
            <div
              className={styles.formContainer}
            >
              <div className={classes.mainList}>
                <form>
                  {discs?.map((item) => {
                    const answere = answeredExam?.find((a) => +item?.id === +a?.question?.id)
                    return (
                      <div key={item.id} className={styles.listContainer}>
                        <h4
                          className={classes.listTile}
                          style={{ color: (!answere && isValid) && 'red' }}
                        >
                          سوال شماره
                          {' '}
                          {item?.order}
                        </h4>
                        <div className={styles.listsStatic}>
                          <p className={styles.listTitle1}>ردیف</p>
                          <p className={styles.listTitle2}>سوال</p>
                          <p className={styles.listTitle3}>بیشترین</p>
                          <p className={styles.listTitle4}>کمترین</p>
                        </div>
                        {item?.options?.map((exam) => {
                          const answered = answeredExam?.find((ans) => ans
                            ?.examOption?.id === +exam?.id)

                          let customStyle = {}

                          if (window.innerWidth < 760 && answered?.examOption?.id === +exam?.id
                              && answered?.examTag?.id === getUserExam
                                ?.exam?.examTags?.[1]?.id) {
                            customStyle = {
                              height: '45px !important',
                              background: '#f55151',
                              backgroundImage: 'url(/images/Union1.svg)',
                              backgroundRepeat: ' no-repeat',
                              backgroundPosition: 'center center',
                              zIndex: 900,
                            }
                          }

                          if (window.innerWidth < 760 && answered?.examOption?.id === +exam?.id
                              && answered?.examTag?.id === getUserExam
                                ?.exam?.examTags?.[0]?.id) {
                            customStyle = {
                              height: '45px !important',
                              background: '#15acbe',
                              backgroundImage: 'url(/images/Union2.svg)',
                              backgroundRepeat: ' no-repeat',
                              backgroundPosition: 'center center',
                              zIndex: 900,
                            }
                          }

                          return (
                            (
                              <div key={exam.id}>
                                <div>
                                  <div className={styles.lists}>
                                    <div
                                      className={styles.perList1}
                                      style={customStyle}
                                    >
                                      <p id="order" button>
                                        {window.innerWidth < 760
                                         && answered?.examOption?.id === +exam?.id
                                        && answered?.examTag?.id === getUserExam
                                          ?.exam?.examTags?.[0]?.id
                                          || window.innerWidth < 760
                                           && answered?.examOption?.id === +exam?.id
                                        && answered?.examTag?.id === getUserExam
                                          ?.exam?.examTags?.[1]?.id ? '' : exam?.order}

                                      </p>
                                    </div>
                                    <div className={classes.perList2}>
                                      <p
                                        onClick={() => handleOpenAnswer(item)}
                                      >
                                        {exam?.title}
                                      </p>
                                    </div>

                                    <div className={classes.perList3}>
                                      <label className={styles.customLabel}>
                                        <input
                                          type="radio"
                                          name={exam?.questionId + uniqNumber}
                                          checked={answered?.examOption?.id === +exam?.id
                                          && answered?.examTag?.id === getUserExam
                                            ?.exam?.examTags?.[1]?.id}
                                          onChange={handleLowChange(item, exam)}
                                        />
                                        <span className={styles.checkmark} />
                                      </label>
                                      <label className={styles.customLabel2}>
                                        <input
                                          type="radio"
                                          name={exam?.questionId}
                                          checked={answered?.examOption?.id === +exam?.id
                                          && answered?.examTag?.id === getUserExam
                                            ?.exam?.examTags?.[0]?.id}
                                          onChange={handleHighChange(item, exam)}
                                        />
                                        <span className={styles.checkmark2} />
                                      </label>
                                    </div>
                                  </div>
                                </div>

                              </div>
                            )
                          )
                        })}

                      </div>
                    )
                  })}
                  {isValid ? <p style={{ color: '#e6332a', fontSize: '15px' }}>لطفا به تمام سوالات پاسخ دهید</p> : null}
                  <div className={classes.submitWrap}>
                    <p className={classes.submitText}>
                      دوست پرتلاش گارنت، اگر از همه‌ی پاسخ‌های خود مطمئن هستی، روی گزینه
                      ارسال کلیک کن، روان‌شناسان و متخصصان گارنت پس از بررسی
                      پاسخ‌های آزمون، تفسیر آزمون‌ها را برایت ارسال می‌کنند.
                      گارنت در مسیر دانایی یار و همراهت می‌ماند.

                    </p>
                    <button type="button" disabled={role?.roleId === 2} onClick={handleOpen} className={classes.submitBtn} style={{ cursor: 'pointer' }}>ارسال پاسخ</button>
                  </div>

                  <Dialog
                    className={classes.deleteDialog}
                    open={submitModal}
                    onClose={() => handleClose(false)}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                  >
                    <DialogTitle className={classes.dialogHeader} id="alert-dialog-title">آیا از ارسال پاسخ اطمینان دارید؟</DialogTitle>
                    <DialogContent>
                      <DialogContentText className={classes.dialogDesc} id="alert-dialog-description">
                        توجه داشته باشید پس از ارسال پاسخ امکان بازگشت به این آزمون را نخواهید داشت
                      </DialogContentText>
                    </DialogContent>
                    <DialogActions className={classes.dialogButtons}>
                      <Button onClick={() => handleClose(false)} className={classes.cancelModalBtn}>
                        لغو
                      </Button>
                      <Button
                        onClick={() => handleSubmit()}
                        className={classes.finalSubmit}
                        autoFocus
                      >
                        پاسخ
                      </Button>
                    </DialogActions>
                  </Dialog>
                </form>
              </div>
              <Dialog
                className={classes.answerModal}
                open={question}
                onClose={handleCloseAnswer}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
              >
                <div className={styles.modalWrap}>
                  <h4 className={classes.listTile}>
                    سوال شماره
                    {' '}
                    {question?.order}
                  </h4>
                  <div className={styles.listsStatic}>
                    <p className={styles.listTitle1}>ردیف</p>
                    <p className={styles.listTitle3inModal}>بیشترین</p>
                    <p className={styles.listTitle4inModal}>کمترین</p>
                  </div>
                  {question?.options?.map((qs) => {
                    const answer = answeredExam?.find((ans) => ans
                      ?.examOption?.id === +qs?.id)
                    return (
                      <div className={styles.lists} key={qs?.id}>
                        <div
                          className={styles.perList1inModal}
                          style={{ height: '45px !important' }}
                        >
                          <p button>{qs?.order}</p>
                        </div>

                        <div className={styles.perList3InModal}>
                          <label className={styles.customLabel}>
                            <input
                              type="radio"
                              name={qs?.questionId + uniqNumber}
                              checked={answer?.examOption?.id === +qs?.id
                                && answer?.examTag?.id === getUserExam
                                  ?.exam?.examTags?.[1]?.id}
                              onChange={handleLowChange(question, qs)}
                            />
                            <span className={styles.checkmark} />
                          </label>
                          <label className={styles.customLabel2}>
                            <input
                              type="radio"
                              name={qs?.questionId}
                              checked={answer?.examOption?.id === +qs?.id
                                && answer?.examTag?.id === getUserExam
                                  ?.exam?.examTags?.[0]?.id}
                              onChange={handleHighChange(question, qs)}
                            />
                            <span className={styles.checkmark2} />
                          </label>
                        </div>
                      </div>
                    )
                  })}
                </div>
              </Dialog>
            </div>
          </div>
          <div />
        </Grid>
      </Card>
    </div>
  )
}

export default DiscQuizCard
